"use client";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body>
        <div style={{ display: "flex", minHeight: "100vh", alignItems: "center", justifyContent: "center", background: "#0a0a0b" }}>
          <div style={{ textAlign: "center" }}>
            <h2 style={{ color: "#f87171", fontFamily: "monospace", fontSize: "14px" }}>something went wrong</h2>
            <button
              onClick={reset}
              style={{ color: "#999", fontFamily: "monospace", fontSize: "12px", marginTop: "16px", cursor: "pointer", background: "none", border: "none" }}
            >
              try again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
